import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightConfigureGlobalRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-configure',
	path: '/jira/servicedesk/insight/configure/global',
};
